export const hearts_bg = require('./bg-hearts.png')